import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Label } from '@blueprintjs/core';

import { getPageOptionLabel } from 'editor-utils/template';

const PageOptionsSelect = props => {
  const [selectedPageOptionsIds, setSelectedPageOptionIds] = useState(props.pageOptionIds);

  const pageOptions = useMemo(
    () =>
      props.pageOptionIds.map(id => ({
        id,
        label: getPageOptionLabel(id),
      })),
    [props.pageOptionIds],
  );

  useEffect(() => {
    props.onChange(selectedPageOptionsIds);
  }, [selectedPageOptionsIds]);

  const handlePageOptionChange = (id, checked) => {
    if (checked) {
      setSelectedPageOptionIds(value => value.filter(item => item !== id));
      return;
    }
    setSelectedPageOptionIds(value => [...value, id]);
  };

  if (pageOptions.length === 0) {
    return null;
  }

  return (
    <>
      <Label>Select the page types you want to include</Label>
      {pageOptions.map(({ id, label }) => {
        const checked = selectedPageOptionsIds.includes(id);

        return (
          <Checkbox
            key={id}
            checked={checked}
            label={label}
            onChange={() => handlePageOptionChange(id, checked)}
          />
        );
      })}
    </>
  );
};

PageOptionsSelect.propTypes = {
  pageOptionIds: PropTypes.array,
  onChange: PropTypes.func,
};

PageOptionsSelect.defaultProps = {
  pageOptionIds: [],
  onChange: () => {},
};

export default PageOptionsSelect;
